'use client';

import React from 'react';
import dynamic from 'next/dynamic';

import { Banner } from './_components/Banner';
import { BannerLoading } from './_components/BannerLoading';
import classes from './index.module.css';
import { BannerSliderProps } from './models';

const Slider = dynamic(() => import('@/widgets/Slider').then((mod) => mod.Slider), { loading: () => <BannerLoading />, ssr: false });

export const BannerSlider = ({ contentData, align = 'center', compact = false }: BannerSliderProps) => {
    const singleBanner = contentData[0];
    const verticalPadding = compact ? 'py-3' : 'py-4';
    const isLeft = align === 'left';

    return (
        <>
            {contentData.length === 1 ? (
                <div
                    dir={isLeft ? 'ltr' : undefined}
                    className={`flex w-full ${verticalPadding} ${isLeft ? 'justify-center lg:justify-start' : 'justify-center md:justify-end'}`}>
                    <div dir='rtl' className='w-full max-w-[450px]'>
                        <Banner bannerData={singleBanner} isSingle />
                    </div>
                </div>
            ) : (
                <div
                    dir={isLeft ? 'ltr' : undefined}
                    className={`w-full max-w-[450px] ${isLeft ? 'mx-auto lg:ml-0 lg:mr-auto' : 'mx-auto'} ${classes.sliderContainer}`}>
                    <div dir='rtl'>
                        <Slider
                            navigation
                            autoplay={{
                                delay: 12000
                            }}
                            className={`w-full max-w-[450px] ${verticalPadding}`}>
                            {contentData.map((banner) => (
                                <Banner key={banner.id} bannerData={banner} />
                            ))}
                        </Slider>
                    </div>
                </div>
            )}
        </>
    );
};
